// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 100;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.sidebar-header h2 {
  color: #333;
  font-size: 1.25rem;
  margin: 0;
}

.project-info {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.9rem;
}

.project-info div {
  margin-bottom: 0.5rem;
  color: #555;
}

.analysis-points {
  flex: 1 1;
  padding: 1rem 0;
}

.analysis-points h3 {
  padding: 0 1.5rem 1rem;
  color: #333;
  font-size: 1rem;
  margin: 0;
}

.points-list {
  display: flex;
  flex-direction: column;
}

.point-btn {
  text-align: left;
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #555;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.point-btn:hover {
  background-color: #f8f9fa;
  color: #333;
}

.point-btn.active {
  background-color: #e3f2fd;
  color: #1976d2;
  border-left-color: #1976d2;
  font-weight: 500;
}

.sidebar-actions {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #555;
  transition: all 0.2s;
}

.action-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.sidebar-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  text-align: center;
}

.sidebar-footer p {
  color: #888;
  font-size: 0.8rem;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX","sourcesContent":[".sidebar {\n  width: 280px;\n  background: white;\n  border-right: 1px solid #dee2e6;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  z-index: 100;\n}\n\n.sidebar-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.sidebar-header h2 {\n  color: #333;\n  font-size: 1.25rem;\n  margin: 0;\n}\n\n.project-info {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #dee2e6;\n  font-size: 0.9rem;\n}\n\n.project-info div {\n  margin-bottom: 0.5rem;\n  color: #555;\n}\n\n.analysis-points {\n  flex: 1;\n  padding: 1rem 0;\n}\n\n.analysis-points h3 {\n  padding: 0 1.5rem 1rem;\n  color: #333;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.points-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.point-btn {\n  text-align: left;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #555;\n  transition: all 0.2s;\n  border-left: 3px solid transparent;\n}\n\n.point-btn:hover {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.point-btn.active {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  border-left-color: #1976d2;\n  font-weight: 500;\n}\n\n.sidebar-actions {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #555;\n  transition: all 0.2s;\n}\n\n.action-btn:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.sidebar-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #dee2e6;\n  text-align: center;\n}\n\n.sidebar-footer p {\n  color: #888;\n  font-size: 0.8rem;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
